export default __webpack_public_path__ + "static/media/testimonial-landingpages-frame.5c7ce69a.jpg";